angular.module("registrationModule").component("registration", {
	templateUrl: "registration/registration.html",
	transclude: true,
	bindings: {
		activeRentalListings: "@",
		activeSaleListings: "@",
		activeStep: "<",
		altText: "@",
		altTitle: "@",
		brokerSearchRpc: "@",
		buildingSearchRpc: "@",
		closable: "<",
		companyPhone: "@",
		emailValidationUrl: "@",
		forgotLink: "@",
		googleClientId: "@",
		imageSrc: "@",
		imageSrcRoot: "@",
		is3rdPartyAccountExistRpc: "@",
		is3rdPartyAccountExistUrl: "@",
		isLeadKitInvite: "<",
		isMobile: "<",
		isCollectionPage: "<",
		isOpened: "<",
		isSignedIn: "<",
		isExtraInfoStep: "<",
		isPhoneStep: "<",
		userType: "@",
		isEmbedded: '<',
		openOnScroll: '<',
		isSignupOnly: '<',
		isLookingForStep: '<',
		listingMaskId: "@",
		buildingId: "@",
		articleId: "@",
		historyId: "@",
		listingSideContactType: "@",
		localStorageDays: "@",
		loginRpc: "@",
		pageId: "@",
		paramKw: "@",
		paramSrc: "@",
		paramTier: "@",
		passwordResetUrl: "@",
		phoneValidationUrl: "@",
		privacyPolicyUrl: "@",
		redirectionUrl: "@",
		rpcRegistrationEmailValidation: "@",
		setPasswordRpc: "@",
		signInUrl: "@",
		signUpExtraInfoRpc: "@",
		signUpRpc: "@",
		signUpUrl: "@",
		submitNameUrl: "@",
		submitExtraInfoUrl: "@",
		submitPhoneNumberUrl: "@",
		termsOfUseUrl: "@",
		gtagAbbreviatedRegistration: "@",
		gtagFullRegistration: "@",
		gtagFullRegistrationWithPhone: "@",
		regTrigger: "@",
		parentPopup: '@',
		text: "@",
		textAlternative: "@",
		version: "@",
		calloutBoxType: '@',
		calloutBoxSourcePage: '@',
		buildingNameOrAddress: "@",
		buildingRegion: "@",
		adDesignEnabled: "@",
		adDesignVersion: "@",
		adDesignLandingType: "@",
		phoneVersion: "@",
		buildingToken: "@",
		listingToken: "@",
		searchToken: "@"
	},
	controller: ["$element", "$sce", "$scope", "$rootScope", "$window", "$cookies", "$http", "$timeout", "$document", "PubSub", "fbService", "crResourcesService", "$interval", function (
		$element, $sce, $scope, $rootScope, $window, $cookies, $http, $timeout, $document, PubSub, fbService, crResourcesService, $interval) {

		var ctrl = this;

		var scrollPosition = 0; // Move this outside the $watch function

		$scope.$watch('$ctrl.isOpened', function (isOpened) {
			if (isOpened) {
				// Save the current scroll position
				scrollPosition = $window.pageYOffset;

				// Add class to lock the scroll
				$document.find('body').css('top', '-' + scrollPosition + 'px').addClass('no-scroll body-fixed');
			} else {
				// Remove class to unlock the scroll
				$document.find('body').removeClass('no-scroll body-fixed').css('top', '');
				$window.scrollTo(0, scrollPosition);

				// $timeout(function() {
				// 	$window.scrollTo(0, scrollPosition);
				// }, 0); // Use $timeout to ensure this runs in the next digest cycle
			}
		});


		var w = angular.element($window);
		this.forceReload = false;
		this.inProgress = false;
		this.redirectUrl = null;
		this.tmpOldText = this.text;
		this.tmpOldTitle = null;
		this.isOneTapInitialized = false;
		this.isFromOneTap = null;
		this.softErrorTracked = false;
		this.useAlternativeText = false;
		this.isSignUpClicked = true;
		this.emailRegTitle = 'Unlock New York';
		this.messageIsClear = true;
		this.$wrapper = $element[0].querySelector(".cmp-registration-content-wrapper");

		this.regularUser = {
			src: this.paramSrc,
			tier: this.paramTier,
			kw: this.paramKw,
			listingMaskId: this.listingMaskId,
			buildingId: this.buildingId,
			historyId: this.historyId,
			articleId: this.articleId,
			version: this.version,
		};
		if (this.buildingNameOrAddress) {
			this.regularUser.address = this.buildingNameOrAddress;
		}
		this.buildingAlertToken = null; // adds alert + saves to the profile
		this.listingAlertToken = null; // adds alert + saves to the profile
		this.searchAlertToken = null; // adds alert + saves to the profile
		this.listingAlertOnBuildingToken = null; // adds alert only

		this.loginUser = {};
		this.fbUser = {};

		this.steps = {
			unlock: "unlock",
			unlockEmailPassword: "unlockEmailPassword",
			unlockLookingTo: "unlockLookingTo",
			thanksForJoining: "thanksForJoining",
			phoneRequest: "phoneRequest",
			thanksForJoiningFinal: "thanksForJoiningFinal",
			signIn: "signIn",
			passwordReset: "passwordReset",
			passwordResetConfirmation: "passwordResetConfirmation",
		};

		this.htmlElement = angular.element(document.querySelector("html"));

		this.errorMessages = {
			required: "This field is required.",
			requiredPhone: "Please enter a phone number",
			email: $sce.trustAsHtml("Are you sure?<br/>This does not look like an email."),
			emailExist: "This email already exists.",
			notFullname: "Please enter a full name.",
			phoneExist: "This phone number has been used. Please use your mobile number.",
			phoneFormat: "This phone number is not valid.",
			phoneShort: "This phone is too short (less than 6 characters).",
			minlength: "Password can't be shorter than 6 characters.",
			maxlength: "Password can't be longer than 64 characters.",
			generic: "Error, please contact us for further assistance.",
			fbError: "Login error. Contact us for further assistance."
		};

		this.calloutBoxTypes = {
			'off-market-deals': 'New Reg - Call-Out Off-Market Listings',
			'new-dev-deals': 'New Reg - Call-Out New Dev Deals',
			'sign-up-for-newsletter': 'New Reg - Call-Out Newsletter',
			'new-listings': 'New Reg - Call-Out New Listings'
		};
		/**
		 * Condition to go to signup/signin (depends on button click in header)
		 */
		this.continueToEmailSignUpOrSignIn = function (isSignUp = true) {
			isSignUp ? this.continueToEmailPassword() : this.continueToSignIn();
		}
		/**
		 * First step for all the screens, signup
		 */
		this.continueToSignUp = function () {
			this.activeStep = this.steps.unlock;
			ctrl.trackStep("Open");
		};
		this.continueToSignUpLogIn = function () {
			ctrl.emailRegTitle = 'Welcome back!';
			this.activeStep = this.steps.unlock;
			ctrl.trackStep("Open");
		};


		this.setSignUpClickedTrue = function () {
			ctrl.text = ctrl.tmpOldText;
			ctrl.emailRegTitle = 'Unlock New York';
			ctrl.isSignUpClicked = 1;
		}

		/**
		 * Registration, step 1 - Email and password fields
		 */
		this.continueToEmailPassword = function () {
			this.trackStep("Continue-to-email");
			this.activeStep = this.steps.unlockEmailPassword;
		};

		/**
		 * Registration, step 2 - Name field (user is registered in this step)
		 */
		this.continueToLookingTo = function (data) {
			if (data.data.usr.firstName && data.data.usr.lastName) {
				this.regularUser.name = data.data.usr.firstName + ' ' + data.data.usr.lastName;
			}

			if (data.data && data.data.usr.userType == "broker") {
				this.activeStep = this.steps.phoneRequest;
			} else {
				if (this.adDesignEnabled !== '1' || this.adDesignVersion == 'B') {
					this.activeStep = this.steps.thanksForJoining;
				} else {
					this.activeStep = this.steps.unlockLookingTo;
				}
			}

			if (this.isFromOneTap && !this.isOpened) {
				this.isFromOneTap = false;
				this.open();
			}
		}

		this.continueToThanksForJoining = function (data) {
			this.regularUser.userType = data.data.usr.userType || undefined;
			this.regularUser.isGoogleUser = data.data.usr.isGoogleUser || false;
			this.regularUser.isFacebookUser = data.data.usr.isFacebookUser || false;
			this.trackStep("Submit");
			this.activeStep = this.steps.thanksForJoining;
		};

		this.continueToPhoneRequest = function () {
			this.activeStep = this.steps.phoneRequest;
		};

		this.continueToThanksForJoiningFinal = function () {
			this.activeStep = this.steps.thanksForJoiningFinal;
		};

		this.continueToSignIn = function () {
			this.trackStep("Sign-in-click");
			this.activeStep = this.steps.signIn;
		};

		this.continueToPasswordReset = function () {
			this.activeStep = this.steps.passwordReset;
		};

		this.continueToPasswordResetConfirmation = function () {
			this.activeStep = this.steps.passwordResetConfirmation;
		};

		this.signUp = function (form) {
			window.crRecaptcha.execute(() => { this.signUpRecaptchaCallback(form); }, "registration", false);
		};

		this.signUpRecaptchaCallback = function (form) {

			var requestData = angular.extend({}, this.regularUser, { reCaptchaTokens: window.crRecaptcha.getTokens() });
			this._postRequest(requestData, form, this.signUpUrl, (data) => {

				// To not show exit popup
				var now = new Date(),
					exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
				$cookies.put('exitPopupShown', 'true', { expires: exp });

				if (typeof (crGtag) !== "undefined" && this.adDesignEnabled == '1') {
					crGtag.track(this.gtagFullRegistration); // we now track it the same way as a default registration, as to the comment in CITY-1623
				}
				if (this.regularUser.isBroker && this.regularUser.licensedAgent) {
					this.continueToThanksForJoiningFinal();
				} else {
					this.continueToLookingTo(data);
				}
			});
		};

		this.submitName = function (form) {
			var interests = ["lookingToBuy", "lookingToRent", "lookingToSell", "lookingToNeither"];
			interests.forEach((e) => {
				if (form[e]) {
					this.regularUser[e] = form[e];
					this.interest = e;
				} else {
					delete this.regularUser[e];
				}
			});

			this._postRequest(this.regularUser, form, this.submitNameUrl, (data) => {
				this.continueToThanksForJoining(data);
			});
		};

		this.submitExtraInfo = function (form) {
			var interests = ["offMarketListings", "newDevelopmentDeals", "sellingYourApartment", "workingWithAnAgent", "marketInsightAndData", "infoFor1stTimeBuyers", "investmentProperties", "virtualToursOfNoFee", "lookingToBuy", "lookingToRent", "lookingToSell", "lookingToNeither", "speakWithAnExpert", "offMarketListingsYes", "offMarketListingsNo", "movingIn30Days", "movingInFewMonths", "movingNotSure", "listedForSaleOrRentYes", "listedForSaleOrRentNo"];
			interests.forEach((e) => {
				if (form[e]) {
					this.regularUser[e] = form[e];
				} else {
					delete this.regularUser[e];
				}
			});

			this._postRequest(this.regularUser, form, this.submitExtraInfoUrl, () => {
				this.continueToPhoneRequest();
				// if (typeof(crGtag) !== 'undefined' && this.adDesignEnabled == '1' && this.interest == 'lookingToBuy') {
				// 	crGtag.track(this.gtagFullRegistrationWithPhone);
				// }
			});
		};

		this.submitPhoneNumber = function (form) {
			this._postRequest(this.regularUser, form, this.submitPhoneNumberUrl, () => {
				if (typeof (crGtag) !== 'undefined' && this.adDesignEnabled != '1') {
					crGtag.track(this.gtagFullRegistrationWithPhone);
				}
				//this.trackStep("Submit");
				this.close();
			});
		};

		this.signIn = function (form) {
			this._postRequest(this.loginUser, form, this.signInUrl, function (data) {
				ctrl.redirectUrl = data.redirectTo || ctrl.redirectUrl;
				ctrl.redirectOrReload();
			});
		};

		this.passwordReset = function (form) {
			this._postRequest(this.loginUser, form, this.passwordResetUrl, function (data) {
				ctrl.continueToPasswordResetConfirmation();
			});
		};

		this._postRequest = function (user, form, url, callback) {
			if (this.inProgress) {
				return;
			}
			this.inProgress = true;

			form.globalErrors = [];

			if (this.regTrigger) {
				user.regTrigger = `${this.pageId}-${this.regTrigger}`;
			}
			user.regPage = $window.location.href;

			if (typeof this.buildingAlertToken !== "undefined" && this.buildingAlertToken !== null) {
				user.buildingAlertToken = this.buildingAlertToken;
			}

			if (typeof this.listingAlertToken !== "undefined" && this.listingAlertToken !== null) {
				user.listingAlertToken = this.listingAlertToken;
			}

			if (typeof this.searchAlertToken !== "undefined" && this.searchAlertToken !== null) {
				user.searchAlertToken = this.searchAlertToken;
			}

			if (typeof this.listingAlertOnBuildingToken !== "undefined" && this.listingAlertOnBuildingToken !== null) {
				user.listingAlertOnBuildingToken = this.listingAlertOnBuildingToken;
			}

			this.addCallOutBoxTypeToRequest(user);

			$http({
				method: "post",
				url: url,
				data: user,
				headers: { "X-Requested-With": "XMLHttpRequest" }
			})
				.success(function (data, status, headers, config) {
					if (typeof data === "object" && data && data.data && typeof data.data.messageIsClear !== "undefined") {
						ctrl.messageIsClear = data.data.messageIsClear;
					} else {
						ctrl.messageIsClear = true;
					}

					if (typeof data === "object" && data && data.data && data.data.status) {
						var oldSocialUser = data && data.data && data.data.usr && (data.data.usr.FBUserWhoWasAlreadyRegistered || data.data.usr.GoogleUserWhoWasAlreadyRegistered);
						ctrl.handleSuccess(data, ctrl.activeStep === ctrl.steps.signIn || oldSocialUser);
						ctrl.inProgress = false;
						ctrl.buildingAlertToken = null;
						ctrl.listingAlertToken = null;
						ctrl.listingAlertOnBuildingToken = null;

						if (typeof callback === "function") {
							callback(data);
						}
					} else {
						ctrl.handleErrors(form, data.data || {});
						ctrl.inProgress = false;
					}
				})
				.error(function (data, status, headers, config) {
					ctrl.handleGenericError(form);
					ctrl.inProgress = false;
				});
		};

		this.addCallOutBoxTypeToRequest = function (requestData) {
			if (!!this.calloutBoxType && !!this.calloutBoxTypes[this.calloutBoxType]) {
				requestData.callOutBoxType = this.calloutBoxTypes[this.calloutBoxType];
			} else {
				requestData.callOutBoxType = "";
			}
		};

		this.validateEmail = function (user, form, callback) {
			var ctrl = this;
			var data = {
				email: user.email
			};

			this.validateRpc = crResourcesService.post2(this.emailValidationUrl, data);
			this.validateRpc.$promise.then(function (response) {
				form.needsValidation = false;
				var emailErrors = response.data.form.email;
				var emailAlreadyInUse = emailErrors && Array.isArray(emailErrors) && emailErrors.some(emailError => emailError.indexOf("is already in use") !== -1);

				if (response.data.status === false && !emailAlreadyInUse) {
					ctrl.handleErrors(form, response.data);
				} else {
					user.isBroker = response.data.isBroker || false;

					if (typeof callback === "function") {
						if (response.data.form.email && response.data.form.email.indexOf("is already in use")) {
							ctrl.loginUser.email = user.email;
							callback(true);
						} else {
							callback(false);
						}
					}
				}
			}, function (response) {
				ctrl.handleGenericError(form);
			});
		};

		this.validatePhone = function (phone, form, callback) {
			var ctrl = this;
			var data = {
				phone: phone
			};

			this.validateRpc = crResourcesService.post2(this.phoneValidationUrl, data);
			this.validateRpc.$promise.then(function (response) {
				form.needsValidation = false;
				if (response.data.status === false) {
					form.needsValidation = true;
					ctrl.handleErrors(form, response.data);
				} else {
					if (typeof callback === "function") {
						callback();
					}
				}
			}, function (response) {
				ctrl.handleGenericError(form);
			});
		};

		this.close = function () {
			// Start the fade effect for inner steps
			let stepsElement = angular.element(document.querySelector('.steps-wrapper'));
			stepsElement.addClass('opaque');

			// After the fade effect duration, proceed with the close logic
			$timeout(() => {
				if (this.activeStep === this.steps.unlock ||
					this.activeStep === this.steps.thanksForJoining ||
					this.activeStep === this.steps.phoneRequest ||
					this.activeStep === this.steps.thanksForJoiningFinal
				) {
					this.trackStep("Close-x");
					if (this.activeStep != this.steps.unlock && this.isSignedIn != '1') this.redirectOrReload();
					this.isOpened = false;
				} else if (this.closable) {
					this.trackStep("Close-x");

					this.isOpened = false;

					this.activeStep = null;
				}
				$document.find('html').removeClass('no-scroll');
			}, 300);  // This should match the transition duration for the fade effect
		};

		this.redirectOrReload = function () {
			this.forceReload = true;

			if (this.redirectUrl) {
				$window.location.href = this.redirectUrl;
			} else {
				$window.location.reload();
			}
		};

		this.trackStep = function (action) {
			var stepsToTrack = [
				this.steps.unlock,
				this.steps.unlockEmailPassword,
				this.steps.unlockLookingTo,
				this.steps.phoneRequest,
				this.steps.thanksForJoining,
				this.steps.thanksForJoiningFinal
			];

			if (stepsToTrack.indexOf(this.activeStep) !== -1) {
				crTrackerQueue.track({
					category: "Registration",
					action: this.activeStep,
					label: action
				});
			}
		};

		this.handleSuccess = function (data, oldUser) {
			if (!oldUser) { // new user signed up
				this.trackStep("Submit");
				$cookies.put("crSignup", true, { path: "/" });

				// NCR-4668, For Queue tracking
				if (data.data.trackQueue) {
					var trackQueue = data.data.trackQueue;
					crTrackerQueue.track(trackQueue);
				}

				// if (data.data && data.data.status === true && data.data.adWordsCampaign) {
				// 	crGtag.track(data.data.adWordsCampaign.send_to, data.data.adWordsCampaign.value);
				// }
			} else { // for socials edge cases

			}

			// if the account is a broker, then hide the preferences subitem in the user menu
			if (data.data.isBroker) {
				var $userMenu = angular.element(document.querySelectorAll(".user_menu"));
				$userMenu.addClass("broker_or_seller");
			}

			if (!data.data.leadkitToken) {
				var $ledkitMenu = angular.element(document.querySelectorAll(".leadkit_item"));
				$ledkitMenu.remove();
			} else {
				var $ledkitLink = angular.element(document.querySelectorAll(".leadkit_link"));
				$ledkitLink.attr("href", data.data.leadkitToken);
			}

		};

		this.handleErrors = function (form, data) {
			if (form && data.form && (data.form.length || Object.keys(data.form).length)) {
				this.softErrorTracked = false;
				angular.forEach(data.form, function (error, key) {
					if (key !== "FORMSUMMARY") {
						// There is no flag to determine what type of error we got from BED
						if (key == 'first_name' || key == 'last_name') key = 'name';

						if (form[key] && error[0]) {
							// duplicated error
							if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0) {
								ctrl.trackSoftError("Duplicate");
								form[key].$setValidity(key + "Exist", false);
							} else if (error[0].indexOf("Your message is not clear") > 0) {
								ctrl.trackSoftError("Message");
								form[key].$setValidity(key + "NotClear", false);
							} else if (error[0].indexOf("incorrect") > 0 || error[0].indexOf("valid") > 0) { // twilio phone error
								ctrl.trackSoftError("Phone");
								form[key].$setValidity("pattern", false);
							} else if (error[0].indexOf("a full name") > 0 || error[0].indexOf("is too short") > 0) {
								ctrl.trackSoftError("Wrong Name");
								form[key].$setValidity("pattern", false);
							} else {
								ctrl.trackSoftError("Other");
							}
						} else {
							ctrl.handleGenericError(form, data.message);
						}
					}
				});
			} else {
				ctrl.handleGenericError(form, data.message || null);
			}
		};

		this.handleGenericError = function (form, message) {
			// we just keep one global error with a generic message
			if (!this.messageIsClear) {
				ctrl.trackSoftError("Message");
				return;
			};
			if (form && form.globalErrors && form.globalErrors.length === 0) {
				var gError = {};
				gError.key = "error";
				gError.value = message || ctrl.errorMessages.generic;
				form.globalErrors.push(gError);
			}
			this.trackHardError();
		};

		this.trackSoftError = function (suffix) {
			if (!this.softErrorTracked) {
				this.trackStep("Submit-Fail-" + suffix);
			}
			this.softErrorTracked = true;
		};

		this.trackHardError = function () {
			this.trackStep("Submit-Fail-Epic");
		};

		this.setGoogleUserFromOneTap = function (token) {
			var googleUser = {
				userInfo: {},
				id_token: token
			};

			window.crRecaptcha.execute(() => {
				if ($rootScope.isExitPopupVisible) {
					this.setExitPopupGoogleUser(googleUser, {});
				} else {
					this.setGoogleUser(googleUser, {});
				}
			}, "registration", false);
		};

		this.setGoogleUser = function (googleUser, form) {
			this.trackStep("Sign-in-click-google");
			var user = angular.extend({}, this.regularUser, { reCaptchaTokens: window.crRecaptcha.getTokens() });
			delete user.email;
			delete user.password;
			user.google = googleUser;
			user.isFromOneTap = this.isFromOneTap;

			this._postRequest(user, form, this.signUpUrl, (data) => {
				if (data.data && data.data.usr && (data.data.usr.isExistingUser || data.data.usr.FBUserWhoWasAlreadyRegistered || data.data.usr.GoogleUserWhoWasAlreadyRegistered)) {
					this.redirectOrReload();
				} else {
					this.continueToLookingTo(data);

					if (typeof (crGtag) !== "undefined" && this.adDesignEnabled == '1') {
						crGtag.track(this.gtagFullRegistration); // we now track it the same way as a default registration, as to the comment in CITY-1623
					}
				}
			});
		};

		this.setExitPopupGoogleUser = function (googleUser, form) {
			this.trackStep("Sign-in-click-google");
			var user = angular.extend({}, this.regularUser, { reCaptchaTokens: window.crRecaptcha.getTokens() });
			delete user.email;
			delete user.password;
			user.google = googleUser;
			user.isExitPopup = true;

			// Save building
			if (ctrl.buildingToken) {
				ctrl.buildingAlertToken = ctrl.buildingToken;
			}

			// Save listing
			if (ctrl.listingToken) {
				ctrl.listingAlertToken = ctrl.listingToken;
			}

			// Save search
			if (ctrl.searchToken) {
				ctrl.searchAlertToken = ctrl.searchToken;
			}

			this._postRequest(user, form, this.signUpUrl, (data) => {
				if (data.data && data.data.usr && (data.data.usr.isExistingUser || data.data.usr.FBUserWhoWasAlreadyRegistered || data.data.usr.GoogleUserWhoWasAlreadyRegistered)) {
					this.redirectOrReload();
				} else {
					PubSub.publish('exitPopupRegSuccess');
				}
			});
		};

		this.fbLogin = function (form) {
			this.trackStep("Sign-in-click-facebook");

			//if user is already logged in to FB
			if (!!this.fbUser.authResponse) {
				fbService.getInfo().then(function (userInfo) {
					if (userInfo) {
						ctrl.setFbUser(userInfo, form);
					}
				});
			} else {
				fbService.login().then(function () {
					return fbService.getLoginStatus();
				}).then(function (loginResponse) {
					if (!loginResponse.authResponse) {
						// sometimes there is a status unknown causing an error
						// form.globalErrors = [];
						// form.globalErrors.push({key: "error", value: ctrl.errorMessages.fbError});
					} else {
						ctrl.fbUser.authResponse = loginResponse.authResponse;
					}
					return fbService.getInfo();
				}).then(function (userInfo) {
					if (userInfo) {
						ctrl.setFbUser(userInfo, form);
					}
				});
			}
		};

		this.setFbUser = function (userInfo, form) {
			window.crRecaptcha.execute(() => {
				var user = angular.extend({}, this.regularUser, { reCaptchaTokens: window.crRecaptcha.getTokens() });
				delete user.email;
				delete user.password;
				user.fb = this.fbUser;
				user.fb.userInfo = userInfo;

				this._postRequest(user, form, this.signUpUrl, function (data) {
					if (data.data && data.data.usr && (data.data.usr.isExistingUser || data.data.usr.FBUserWhoWasAlreadyRegistered || data.data.usr.GoogleUserWhoWasAlreadyRegistered)) {
						ctrl.redirectOrReload();
					} else {
						ctrl.continueToLookingTo(data);

						if (typeof (crGtag) !== "undefined" && this.adDesignEnabled == '1') {
							crGtag.track(this.gtagFullRegistration); // we now track it the same way as a default registration, as to the comment in CITY-1623
						}
					}
				});
			}, "registration", false);
		};

		this.focusOnFirst = function () {
			const tabElements = this.$wrapper.querySelectorAll("a, button, input");
			tabElements[0] && tabElements[0].focus();
		};

		this.open = function () {

			let stepsElement = angular.element(document.querySelector('.steps-wrapper'));
			stepsElement.removeClass('opaque');

			ctrl.isOpened = true;

			$timeout(() => { ctrl.focusOnFirst(); }, 300); // add a delay to make sure the focus stay on the field (fix issue for collection page)
		};


		this.openPublic = () => {
			this.continueToSignUp();
			this.open();
		};

		this.googleButtonInit = function () {
			if (typeof gapi === "undefined") {
				$timeout(function () { ctrl.googleButtonInit(); }, 100);
			} else {
				gapi.load('auth2', function () {
					gapi.auth2.init({
						client_id: ctrl.googleClientId
					});
				});
			}
		};

		this.oneTapInit = function () {
			if (typeof google === "undefined") {
				$timeout(function () { ctrl.oneTapInit(); }, 100);
			} else {
				google.accounts.id.initialize({
					client_id: ctrl.googleClientId,
					prompt_parent_id: "google-one-tap",
					cancel_on_tap_outside: false,
					callback: function (response) {
						ctrl.oneTapCallback(response);
					}
				});
				ctrl.isOneTapInitialized = true;
			}
		};

		this.oneTapPrompt = function () {
			if (typeof google === "undefined" || !ctrl.isOneTapInitialized) {
				$timeout(function () { ctrl.oneTapPrompt(); }, 100);
			} else {
				google.accounts.id.prompt((notification) => {
					if (!!notification && !!notification.m && notification.m == 'user_cancel') {
						ctrl.hideOneTapText();
					}
					if (notification.isNotDisplayed() || notification.isSkippedMoment() || notification.isDismissedMoment()) {
						ctrl.hideOneTapText();
					}
					if (notification.isDisplayed()) {
						// wait for the google one tap to be rendered
						let intervalLoadGoogleOneTap = $interval(() => {
							let googleOneTap = document.querySelector('#google-one-tap');
							let googleOneTapIframe = document.querySelector('#credential_picker_iframe') || document.querySelector('#credential_picker_container');

							if (googleOneTap && googleOneTapIframe) {

								let googleOneTapTextDiv = document.createElement("div");
								googleOneTapTextDiv.classList.add("google-one-tap-text");
								const txtNode = document.createTextNode("Sign in to get the latest listings!");
								googleOneTapTextDiv.appendChild(txtNode);

								if (ctrl.isMobile) {
									// let existingGoogleOneTapText = document.querySelector('.google-one-tap-text');
									// if (!existingGoogleOneTapText) {
									// 	googleOneTapIframe.style.top = 0;
									// 	googleOneTapIframe.style.bottom = 'unset';
									// 	googleOneTapTextDiv.style.position = 'fixed';
									// 	googleOneTapTextDiv.style.width = '100%';
									// 	googleOneTapTextDiv.style.top = (parseInt(googleOneTapIframe.style.height, 10) - 4) + 'px';
									// 	googleOneTapTextDiv.style.marginLeft = '-2px';
									// 	googleOneTapTextDiv.style.zIndex = '9999';
									// 	document.body.insertBefore(googleOneTapTextDiv, googleOneTapIframe.nextSibling);
									// }
								} else if (this.pageId !== 'rpf') {
									let existingGoogleOneTapText = googleOneTap.querySelector('.google-one-tap-text');
									if (!existingGoogleOneTapText) {
										googleOneTap.insertBefore(googleOneTapTextDiv, googleOneTap.children[0]);
									}
								}

								$interval.cancel(intervalLoadGoogleOneTap);
							}
						}, 500, 10);
					}
				});
			}
		};

		this.oneTapCallback = function (response) {
			if (response.credential) {
				ctrl.hideOneTapText();
				this.isFromOneTap = true;
				ctrl.setGoogleUserFromOneTap(response.credential);
			} else if (response.status == 'ERROR') {
				ctrl.hideOneTapText();
			} else if (response.status == 'CLOSED') {
				ctrl.hideOneTapText();
			} else {
				ctrl.hideOneTapText();
			}
		};

		this.hideOneTapText = () => {
			let googleOneTapTextAll = document.querySelectorAll('.google-one-tap-text');
			if (!!googleOneTapTextAll) {
				angular.forEach(googleOneTapTextAll, (value, index) => {
					googleOneTapTextAll[index].style.display = 'none';
				});
			}
		}

		var onResize = function () {
			ctrl.googleButtonRender();
		};

		w.on('resize', onResize);

		// Clean up the event listener when the scope is destroyed
		$scope.$on('$destroy', function () {
			w.off('resize', onResize);
		});

		this.googleButtonRender = function (suffix = 'email') {
			if (typeof google === "undefined") {
				$timeout(function () { ctrl.googleButtonRender(suffix); }, 100);
			} else {
				let width = window.innerWidth < 1180 ? "280" : "334";
				var elem = document.getElementById("google-signin-" + suffix);
				google.accounts.id.renderButton(
					elem, {
					theme: "outline",
					size: "large",
					width: width,
					text: "continue_with",
				}
				);
			}
		};

		this.addRegOnClick = function (btn) {
			angular.element(btn).off("click").on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				var dataCallOut = btn.getAttribute("data-call-out");
				if (!!dataCallOut && !!ctrl.calloutBoxTypes[dataCallOut]) {
					ctrl.calloutBoxType = dataCallOut;
					ctrl.calloutBoxSourcePage = btn.getAttribute("data-callout-page-type") || null;
				} else {
					ctrl.calloutBoxType = null;
					ctrl.calloutBoxSourcePage = null;
				}

				let tabClasses = btn.className.split(" ");
				let saveBuilding = false;
				let saveListing = false;
				let couldBeListingAlertSometimesMaybe = false;

				if (btn.getAttribute("data-use-save-acris-text") == 1) {
					ctrl.text = "Link to ACRIS is available only to members.<br/> Register now to get full access!<br/><b>There's no obligation.</b>";

					if (!ctrl.tmpOldTitle) {
						ctrl.tmpOldTitle = ctrl.emailRegTitle;
					}
					ctrl.emailRegTitle = "ACRIS Filing Docs";

				} else if (btn.getAttribute("data-use-save-building-text") == 1 && btn.getAttribute("data-use-alternative-text") != 1 && ((typeof btn.hasClass === "function") && !btn.hasClass("alt_text"))) {
					ctrl.text = "To receive alerts when new apartment are listed in this building, please sign up. <br/> <b>It's quick and easy.</b>";

					if (!ctrl.tmpOldTitle) {
						ctrl.tmpOldTitle = ctrl.emailRegTitle;
					}
					ctrl.emailRegTitle = "Be the First to Know";

					saveBuilding = true;
				} else if (btn.getAttribute("data-use-save-listing-text") == 1) {

					ctrl.text = "Join CityRealty to save listings and get email alerts with the newest listings.<br/><b>It's quick and easy.</b>";

					if (!ctrl.tmpOldTitle) {
						ctrl.tmpOldTitle = ctrl.emailRegTitle;
					}

					ctrl.emailRegTitle = "Save this listing";
					saveListing = true;
				} else if (btn.getAttribute("data-use-alternative-text") == 1 || ((typeof btn.hasClass === "function") && btn.hasClass("alt_text"))) {
					ctrl.text = ctrl.altText;

					if (ctrl.altTitle) {
						if (!ctrl.tmpOldTitle) {
							ctrl.tmpOldTitle = ctrl.emailRegTitle;
						}
						ctrl.emailRegTitle = ctrl.altTitle;
					}

					couldBeListingAlertSometimesMaybe = true;
				} else if (!(btn.attributes["target"] && btn.attributes["target"].value === "sign-in") && tabClasses.indexOf("_signin") == -1) {
					ctrl.text = ctrl.tmpOldText;
					if (!ctrl.tmpOldTitle) {
						ctrl.tmpOldTitle = ctrl.emailRegTitle;
					}
					ctrl.emailRegTitle = 'Unlock New York';
				} else if ((btn.attributes["target"] && btn.attributes["target"].value === "sign-in") || tabClasses.indexOf("_signin") !== -1) {
					if (!ctrl.tmpOldTitle) {
						ctrl.tmpOldTitle = ctrl.emailRegTitle;
					}
					ctrl.emailRegTitle = 'Welcome back!';
				} else {
					if (ctrl.tmpOldText) {
						ctrl.text = ctrl.tmpOldText;
					}
					if (ctrl.tmpOldTitle) {
						ctrl.emailRegTitle = ctrl.tmpOldTitle;
						ctrl.tmpOldTitle = null;
					}

					saveBuilding = false;
					saveListing = false;
					couldBeListingAlertSometimesMaybe = false;
				}

				let token;
				if (saveBuilding) {
					if (token = btn.getAttribute("data-building-token")) {
						ctrl.buildingAlertToken = token;
					} else if (ctrl.buildingToken) {
						ctrl.buildingAlertToken = ctrl.buildingToken;
					}
				}

				if (saveListing) {
					let tmpRpc = null;
					if (token = btn.getAttribute("data-listing-token")) {
						ctrl.listingAlertToken = token;
					} else if (ctrl.listingToken) {
						ctrl.listingAlertToken = ctrl.listingToken;
					} else if (tmpRpc = btn.getAttribute("data-rpc-save-to-profile")) {
						// as a last resort, try parsing rpc usr, as there too may place the data could be coming from to keep track of them all
						let match = tmpRpc.match(/\?t=([\d\w]+\-[\d\w]+)/);

						if (match && typeof match[1] !== "undefined") {
							ctrl.listingAlertToken = match[1];
						}
					}
				}

				if (couldBeListingAlertSometimesMaybe) {
					if (token = btn.getAttribute("data-listing-alerts-on-buildings-token")) {
						ctrl.listingAlertOnBuildingToken = token;
					}
				}

				ctrl.regTrigger = btn.getAttribute("data-reg-trigger");
				$scope.$apply();

				// if we have the target attribute set to sign-in (for mobile)
				// or if we have the class _signin (desktop)
				if ((btn.attributes["target"] && btn.attributes["target"].value === "sign-in") || tabClasses.indexOf("_signin") >= 0) {
					ctrl.isSignUpClicked = false;
					ctrl.continueToSignUpLogIn();
				} else {
					ctrl.isSignUpClicked = true;
					ctrl.continueToSignUp();
				}

				//ctrl.oneTapPrompt();
				ctrl.open();

				let eventName = btn.getAttribute("data-registration-event-to-fire");
				if (eventName) {
					var event = document.createEvent("HTMLEvents");
					event.initEvent(eventName, true, true);
					document.dispatchEvent(event);
				}
			});
		};

		this.willClose = (data) => {
			if (data.type === 'close') {
				this.close();
			}
		};

		this.isCloseVisible = () => {
			if (this.emailRegTitle == 'Save this listing' || this.emailRegTitle == 'Be the First to Know' || this.emailRegTitle == 'ACRIS Filing Docs') return true;
			if (this.activeStep == this.steps.thanksForJoiningFinal) return true;
			if (this.pageId == 'bga') return true;
			if (this.activeStep == this.steps.thanksForJoining && this.adDesignVersion == 'B') return false; // Version B (ad) - not closeable
			if (this.activeStep == this.steps.phoneRequest && (this.adDesignEnabled == '1' && this.phoneVersion == 'A')) return false; // Phone step can't be closed ad flow A
			if (this.activeStep == this.steps.phoneRequest) return true; // Phone step can be closed on all other flows
			if (!this.closable) return false; // Closable?
			if (this.activeStep == this.steps.unlockLookingTo) return false; // "Looking to" can't be closed
			if (this.adDesignEnabled == '1' && (this.activeStep == this.steps.unlock || this.activeStep == this.steps.unlockEmailPassword || this.activeStep == this.steps.signIn)) return false;
			if (this.adDesignEnabled == '1' && this.interest) return false; // for ad users looking to buy/rent
			//if (this.activeStep == this.steps.thanksForJoining && this.adDesignEnabled !== '1') return false; // General Flow - can't be closed


			return true;
			//$ctrl.closable == 1 && $ctrl.activeStep !== $ctrl.steps.unlockLookingTo && ($ctrl.activeStep !== $ctrl.steps.thanksForJoining || $ctrl.version !== 'B') && ($ctrl.activeStep !== $ctrl.steps.thanksForJoining || $ctrl.adDesignEnabled !== '1' )
		}

		this.$postLink = function () {
			var $config = angular.element(document.querySelector(".cmp-registration .config"));
			var $regLinks = angular.element(document.querySelectorAll(".reg_blimp"));
			var $regLinksA = angular.element(document.querySelectorAll(".reg_blimp_a"));
			var configText = $config.text();
			if (configText) {
				this.config = angular.fromJson(configText);
			}

			angular.forEach($regLinksA, function (btn) {
				ctrl.addRegOnClick(btn);
			});
			angular.forEach($regLinks, function (btn) {
				ctrl.addRegOnClick(btn);
			});
		};

		this.$onInit = function () {
			this.removeTabbingRestriction = Core.disableTabbingOutside(this.$wrapper);

			if (this.parentPopup) {
				PubSub.subscribe('cr-popup-update-state-' + this.parentPopup, this.willClose);
			}

			PubSub.subscribe('cr-popup-open-' + this.parentPopup, this.openPublic);

			// open on scroll
			if (this.openOnScroll === "1") {
				let showEntryPopup = false;
				w.bind('scroll', () => {
					const scrolledPercentage = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
					if (!showEntryPopup && scrolledPercentage > 25) {
						this.activeStep = this.steps.unlock;
						ctrl.trackStep("Open");
						this.open();
						showEntryPopup = true;
					}
				});
			}
		};

		this.$onDestroy = function () {
			this.removeTabbingRestriction && this.removeTabbingRestriction();
			this.removeTabbingRestriction = null
		};

		// Add GLOBAL event listener (jquery and mootools)
		document.addEventListener("addRegLink", function (e) {
			ctrl.addRegOnClick(e.eventEl);
		});

		// onbeforeunload doesn't fire on mobile so we have to use onpagehide instead.
		if ("onpagehide" in $window) {
			$window.onpagehide = function () {
				if (!ctrl.forceReload) {
					ctrl.trackStep("close-Tab/Url");
				}
			};
		} else {
			$window.onbeforeunload = function () {
				if (!ctrl.forceReload) {
					ctrl.trackStep("close-Tab/Url");
				}
			};
		}


		// this.isOpened = true;
		if (this.isOpened && !this.isExtraInfoStep) {
			if (this.isLeadKitInvite) {
				this.activeStep = this.steps.thanksForJoiningFinal;
			} else if (this.isLookingForStep) {
				if (this.adDesignEnabled !== '1' || this.adDesignVersion == 'B') {
					this.activeStep = this.steps.thanksForJoining;
				} else {
					this.activeStep = this.steps.unlockLookingTo;
				}
			} else if (this.isPhoneStep) {
				this.interest = this.userType;
				this.activeStep = this.steps.phoneRequest;
			} else {
				this.activeStep = this.steps.unlock;
			}

			ctrl.open();
			ctrl.trackStep("Open");
		}
		if (this.isExtraInfoStep) {
			this.interest = this.userType;
			this.activeStep = this.steps.thanksForJoining;
			ctrl.open();
			ctrl.trackStep("Open");
		}

		this.googleButtonInit();
		if (this.isLookingForStep != '1' && this.isExtraInfoStep != '1' && this.isPhoneStep != '1' && this.isSignedIn != '1') {
			this.oneTapInit();
			this.oneTapPrompt();
		}

		// this.activeStep = this.steps.phoneRequest;
		// ctrl.open();

		// TODO: debug code - to remove
		// this.version = "E";
		// this.activeStep = this.steps.unlockEmailPassword;
		//this.activeStep = this.steps.unlockEmailPassword;
		// this.activeStep = this.steps.thanksForJoining;
		//this.activeStep = this.steps.phoneRequest;
		// this.activeStep = this.steps.thanksForJoiningFinal;
		// this.regularUser.isGoogleUser = true;
		// this.open();

		// this.regularUser.email = "test+" + Date.now() + "@test.com";
		// this.regularUser.email = "test+" + Date.now() + "@cityrealty.com";
		// this.regularUser.name = "Vv Rr";
		// this.regularUser.password = "123456";
		// this.regularUser.phone = "2122098801"
		// this.regularUser.lookingToBuy = true;
		// this.regularUser.offMarketListings = true;
		// this.regularUser.newDevelopmentDeals = true;
		// this.regularUser.sellingYourApartment = true;
		// this.regularUser.infoFor1stTimeBuyers = true;
		// this.regularUser.workingWithAnAgent = true;
		// this.regularUser.marketInsightAndData = true;

	}]
});
